import { Injectable, inject } from "@angular/core";
import { DateAdapter } from "@angular/material/core";
import { DateRange, MatDateRangeSelectionStrategy } from "@angular/material/datepicker";
import { DateRangeStrategyManagerService } from "./date-range-strategy.manager.service";
import { DaysModeEnum, PeriodsOffsetMap } from "../../_enums/days-mode.enum";

@Injectable()
export class PlannerCustomRangeSelectionStrategy<D> implements MatDateRangeSelectionStrategy<D> {
    constructor(private strategyManager: DateRangeStrategyManagerService) {
    }

    private _dateAdapter = inject<DateAdapter<D>>(DateAdapter<D>);

    selectionFinished(date: D | null): DateRange<D> {
        return this._createRange(date, this.strategyManager.currentSelectedStrategy);
    }

    createPreview(activeDate: D | null): DateRange<D> {
        return this._createRange(activeDate, this.strategyManager.currentSelectedStrategy);
    }

    private _createRange(date: D | null, currentSelectedStrategy: DaysModeEnum): DateRange<D> {
        if (date) {

            if (currentSelectedStrategy !== DaysModeEnum.DAY) {
                const currentDayOfWeek = this._dateAdapter.getDayOfWeek(date);
                const startDay = this._dateAdapter.addCalendarDays(date, -currentDayOfWeek + 1);
                const endDay = this._dateAdapter.addCalendarDays(startDay, PeriodsOffsetMap[currentSelectedStrategy] - 1);

                return new DateRange<D>(startDay, endDay);
            } else {
                return new DateRange<D>(date, date);
            }
        }

        return new DateRange<D>(null, null);
    }
}